import React, { useEffect, useState } from "react";

const Countdown = () => {
  const calculateTimeLeft = () => {
    const targetDate = new Date("2025-11-20T00:00:00"); 
    const now = new Date();
    const difference = targetDate - now;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex justify-center items-center text-white py-8">
      <div className="flex space-x-6">
        {/* Days */}
        <div className="flex flex-col items-center relative">
          {/* "Starts in" positioned above the number of days */}
          <span className="absolute -top-6 -left-10 text-sm text-white-600 uppercase">
            Starts in
          </span>
          <span className="text-6xl">{timeLeft.days || "00"}</span>
          <span className="text-sm text-gray-400 uppercase">Days</span>
        </div>

        {/* Hours */}
        {/* <div className="flex flex-col items-center">
          <span className="text-6xl">{timeLeft.hours || "00"}</span>
          <span className="text-sm text-gray-400 uppercase">Hours</span>
        </div> */}

        {/* Minutes */}
        {/* <div className="flex flex-col items-center">
          <span className="text-6xl">{timeLeft.minutes || "00"}</span>
          <span className="text-sm text-gray-400 uppercase">Minutes</span>
        </div> */}

        {/* Seconds */}
        {/* <div className="flex flex-col items-center">
          <span className="text-6xl text-indigo-600">
            {timeLeft.seconds || "00"}
          </span>
          <span className="text-sm text-gray-400 uppercase">Seconds</span>
        </div> */}
      </div>
    </div>
  );
};

export default Countdown;
